const BYTES_IN_MEGABYTE = 1024 * 1024;
const BYTES_IN_GIGABYTE = 1024 * BYTES_IN_MEGABYTE;

export const formatFileSize = (bytes: number): string =>
  bytes >= BYTES_IN_GIGABYTE
    ? `${Math.round(bytes / BYTES_IN_GIGABYTE)} Go`
    : `${Math.round(bytes / BYTES_IN_MEGABYTE)} Mo`;
